/**
 * @file
 * Contador animado para métricas destacadas.
 */

(function () {
  "use strict";

  /**
   * Anima um número de 0 até o valor final preservando HTML.
   */
  function animateCounter(element, targetValue, duration, hasNegative) {
    const startTime = performance.now();
    const startValue = 0;
    const originalHTML = element.dataset.originalHtml;

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (ease-out cubic)
      const easeProgress = 1 - Math.pow(1 - progress, 3);

      const currentValue = Math.floor(
        startValue + (targetValue - startValue) * easeProgress,
      );

      // Cria um elemento temporário para manipular o HTML
      const temp = document.createElement("div");
      temp.innerHTML = originalHTML;

      // Função para substituir texto dentro de nós de texto preservando tags
      function replaceTextContent(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          if (/\d+/.test(text)) {
            node.textContent = text.replace(/\d+/g, currentValue);
          }
        } else {
          node.childNodes.forEach((child) => replaceTextContent(child));
        }
      }

      replaceTextContent(temp);
      element.innerHTML = temp.innerHTML;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        // Garante que o valor final seja exato
        temp.innerHTML = originalHTML;
        replaceTextContent(temp);
        element.innerHTML = temp.innerHTML;

        // Adiciona animação de pulse ao finalizar
        element.style.transition = "transform 0.3s ease-out";
        element.style.transform = "scale(1.15)";

        setTimeout(() => {
          element.style.transform = "scale(1)";
        }, 300);
      }
    }

    requestAnimationFrame(update);
  }

  /**
   * Extrai o número inteiro de um texto HTML.
   */
  function extractNumber(html) {
    const text = html.replace(/<[^>]*>/g, "").trim();
    const match = text.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  /**
   * Inicializa os contadores quando entram na viewport.
   */
  function initCounters() {
    const elements = document.querySelectorAll(
      ".paragraph--type--metricas-item .field--name-field-metrica-numeros",
    );

    if (elements.length === 0) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.dataset.animated) {
            const element = entry.target;
            const originalHTML = element.innerHTML;
            const targetNumber = extractNumber(originalHTML);

            if (targetNumber > 0) {
              // Guarda o HTML original
              element.dataset.originalHtml = originalHTML;
              element.dataset.animated = "true";

              // Duração de 7 segundos
              const duration = 7000;

              animateCounter(element, targetNumber, duration);
            }

            observer.unobserve(element);
          }
        });
      },
      {
        threshold: 0.3,
        rootMargin: "50px",
      },
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  // Inicializa
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCounters);
  } else {
    initCounters();
  }
})();
